import components from '@/layout/config/components';
import actionTypes from '../actions/user/actionType';

interface Ipermission {
  category: number;
  checked: boolean;
  code: string;
  description: string;
  id: number;
  name: string;
}
interface Imenu {
  apiServiceName: string; // 服务名
  category: number; // 类别
  checked: boolean; // 是否选择
  children: Array<Imenu>; // 子菜单
  code: string; // 菜单编码
  component: string; // 内容
  fontIcon: string;
  icon: string; // 图标
  id: number; // 菜单id
  name: string; // 菜单名称
  orderNum: number; // 排序
  parentId: number; // 父菜单id
  parentIdList: Array<string>; // 父级id集合
  path: string; // 路径
  permissionMenuId: number; // 权限对应的菜单ID
  permissions: Array<Ipermission>; // 权限列表
  preview: string; // 菜单预览图
  remark: string;
  selectedIcon: string; // 选中状态图标
  tabMenus: Array<any>; // tab菜单
  type: number; // 菜单类型
  unselectedIcon: string; // 未选中状态图标
  visible: number;
}

interface Irole {
  code: string;
  id: number;
  name: string;
}
interface Ishop {
  shopName: string;
}
interface shortcutsObj {
  menuShortcuts: Array<{ menu: Array<string>; path: string; key: string }>;
  funcShortcuts: Array<{ func: string; path: string; key: string }>;
  groupShortcuts: Array<{ menu: Array<string>; path: string; key: string }>;
  storePageEntry: Array<{ menu?: Array<string>; path: string; key: string; func?: string }>;
  groupPageEntry: Array<{ menu: Array<string>; path: string; key: string }>;
}
export interface IuserState {
  userInfo: {
    employeeNo: string;
    name: string;
    userId: string;
  };
  permissions: Array<Partial<Ipermission>>;
  roles: Array<Partial<Irole>>;
  shops: Array<Partial<Ishop>>;
  menus: Array<Partial<Imenu>>;
  currentEmployeeLoading: boolean;
  submenus: Array<Partial<Imenu>>;
  siderCollapsed: boolean;

  departmentType: number;
  departmentCodeList: Array<string>;
  shortcuts: shortcutsObj;
}

interface IState extends IuserState {
  companyGroup: any;
}

const initialState: IState = {
  userInfo: {
    employeeNo: '',
    name: '',
    userId: '',
  },
  permissions: [],
  roles: [],
  shops: [],
  menus: [],
  currentEmployeeLoading: false,

  submenus: [],
  siderCollapsed: false,

  departmentType: null,
  departmentCodeList: [],
  companyGroup: null,
  shortcuts: {
    storePageEntry: [],
    groupPageEntry: [],
    menuShortcuts: [],
    funcShortcuts: [],
    groupShortcuts: [],
  },
};

// dynamic generate submenus
const generateSubmenus = (menuList) => {
  return menuList?.map((m) => {
    const tmp = {
      ...m,
    };
    if (m.component && components[m.component]) {
      tmp.component = components[m.component];
    }
    if (m.children && m.children.length > 0) {
      tmp.children = generateSubmenus(m.children);
    }
    return tmp;
  });
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.TOGGLE_LOADING: {
      const loading = state[payload];
      return {
        ...state,
        [payload]: !loading,
      };
    }
    case actionTypes.UPDATE_SHORTCUT_CONFIG:
      return {
        ...state,
        shortcuts: payload,
      };
    case actionTypes.CACHE_USER_INFO:
      return {
        ...state,
        ...payload,
      };
    case actionTypes.INIT_SUBMENU:
      const { submenus: submenuList } = payload;
      const submenus = generateSubmenus(submenuList);
      return {
        ...state,
        submenus,
      };
    case actionTypes.TOGGLE_SIDER_COLLAPSED:
      const { siderCollapsed } = payload;
      return {
        ...state,
        siderCollapsed,
      };
    default:
      return state;
  }
};
